import { ReactElement } from 'react';

import { Stack, Box } from '@mui/material';

import { SectionProps } from './types';

import Container from '../Container';
import Title from '../Title';

export default function Section({ children, title, id }: SectionProps): ReactElement {
  return (
    <Container id={id} sx={{ px: 4, pt: 8, pb: 12 }}>
      <Stack direction='column' justifyContent='center' alignItems='center'>
        <Title title={title} />

        <Box width='100%' my={3}>
          {children}
        </Box>
      </Stack>
    </Container>
  );
}
